export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30 pointer-events-none"></div>

      <div className="w-full px-4 md:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 py-10 md:py-16">
          <div className="flex-1 w-full max-w-2xl">
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                <i className="ri-fire-line text-sm w-4 h-4 flex items-center justify-center"></i>
                每日更新
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                <i className="ri-hd-line text-sm w-4 h-4 flex items-center justify-center"></i>
                高清画质
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                <i className="ri-database-2-line text-sm w-4 h-4 flex items-center justify-center"></i>
                海量资源
              </span>
            </div>

            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
              7777影院 — 免费高清影视在线观看平台
            </h1>

            <p className="mt-4 text-lg md:text-xl text-primary-600 font-heading font-semibold">
              最新电影、热门电视剧、精彩综艺，一秒不缓冲
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
              7777影院是专业的免费高清影视在线观看平台，涵盖最新上映的院线大片、热播电视剧、人气综艺节目以及经典动漫番剧。
              资源每日更新，支持1080P高清画质在线播放，无需下载、无需等待缓冲，打开即看。
              无论你是电影迷、剧集控还是综艺咖，7777影院都为你准备了最全最新的影视内容库，让追剧观影变得简单又畅快。
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-6 md:gap-10">
              <div className="flex items-center gap-2">
                <span className="font-heading font-bold text-2xl md:text-3xl text-primary-600">12000+</span>
                <span className="text-xs md:text-sm text-foreground-500">影视资源</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="font-heading font-bold text-2xl md:text-3xl text-accent-600">每日50+</span>
                <span className="text-xs md:text-sm text-foreground-500">内容更新</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="font-heading font-bold text-2xl md:text-3xl text-secondary-600">1080P</span>
                <span className="text-xs md:text-sm text-foreground-500">高清画质</span>
              </div>
            </div>

            <div className="mt-8 flex flex-wrap gap-4">
              <button
                onClick={() => scrollTo('#index')}
                className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
                开始追剧
              </button>
              <button
                onClick={() => scrollTo('#app')}
                className="px-6 py-3 bg-background-50 hover:bg-background-100 text-foreground-700 font-medium text-sm rounded-lg border border-background-300 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
                下载APP
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-xl">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20movie%20theater%20experience%20with%20warm%20ambient%20red%20and%20gold%20lighting%2C%20film%20projector%20beam%20cutting%20through%20darkness%2C%20elegant%20velvet%20curtains%2C%20abstract%20cinematic%20composition%2C%20luxurious%20atmosphere%2C%20professional%20movie%20industry%20aesthetic%2C%20soft%20dramatic%20shadows%2C%20high%20contrast%20warm%20tones%2C%20no%20people%2C%20artistic%20photography&width=1200&height=900&seq=hero-cinema-2026&orientation=landscape"
                alt="7777影院 — 沉浸式影视观影体验"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}